import { createDraftSafeSelector } from '@reduxjs/toolkit'

import { RootState } from 'src/Redux'
import { SliceStatus } from 'src/Redux/types'

import { TiktokCampaignState } from '.'

const getState = (state: RootState): TiktokCampaignState =>
  state.scheduling.tiktok

export const getScheduledTikTokCampaign = createDraftSafeSelector(
  getState,
  ({ campaign }) => campaign,
)

export const getScheduledTikTokCampaignComment = createDraftSafeSelector(
  getState,
  ({ campaign }) => campaign.comment,
)

export const getIsIdleTikTokCampaign = createDraftSafeSelector(
  getState,
  ({ status }) => status === SliceStatus.Idle,
)
export const getIsLoadingTikTokCampaign = createDraftSafeSelector(
  getState,
  ({ status }) => status === SliceStatus.Loading,
)
